import React, { useState, useEffect } from 'react';
import { getTeacherTimetable } from '../../api';
import { toast } from 'react-toastify';

const TeacherTimetable = () => {
  const [timetable, setTimetable] = useState([]);
  const days = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

  useEffect(() => { loadTimetable(); }, []);

  const loadTimetable = async () => {
    try {
      const res = await getTeacherTimetable();
      setTimetable(res.data);
    } catch (err) {
      toast.error('Error loading timetable');
    }
  };

  return (
    <div>
      <h3 style={styles.title}>📅 My Timetable</h3>

      {timetable.length === 0 && (
        <div style={styles.empty}>No timetable assigned yet!</div>
      )}

      {days.map(day => {
        const dayEntries = timetable.filter(t => t.day === day);
        if (dayEntries.length === 0) return null;
        return (
          <div key={day} style={styles.dayCard}>
            <h4 style={styles.dayTitle}>📅 {day}</h4>
            <div style={styles.entriesGrid}>
              {dayEntries.map(entry => (
                <div key={entry.id} style={styles.entryCard}>
                  <div style={styles.timeBlock}>
                    <span style={styles.time}>{entry.start_time}</span>
                    <span style={styles.timeSep}>to</span>
                    <span style={styles.time}>{entry.end_time}</span>
                  </div>
                  <div style={styles.entryInfo}>
                    <h5 style={styles.subjectName}>{entry.subject_name}</h5>
                    <p style={styles.className}>{entry.class_name}</p>
                    {entry.room_number && (
                      <p style={styles.room}>🏫 Room: {entry.room_number}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

const styles = {
  title: { color: '#1a6b3a', marginBottom: '20px' },
  empty: { textAlign: 'center', color: '#999', padding: '40px', background: 'white', borderRadius: '12px' },
  dayCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '15px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  dayTitle: { color: '#1a6b3a', margin: '0 0 15px', fontSize: '16px', borderBottom: '2px solid #28a745', paddingBottom: '8px' },
  entriesGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '12px' },
  entryCard: { background: '#f0fff4', borderRadius: '8px', padding: '15px', borderLeft: '4px solid #28a745', display: 'flex', gap: '12px', alignItems: 'flex-start' },
  timeBlock: { display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: '60px' },
  time: { color: '#1a6b3a', fontWeight: 'bold', fontSize: '13px' },
  timeSep: { color: '#999', fontSize: '11px' },
  entryInfo: { flex: 1 },
  subjectName: { color: '#1a6b3a', margin: '0 0 4px', fontSize: '14px' },
  className: { color: '#666', fontSize: '12px', margin: '0 0 4px' },
  room: { color: '#888', fontSize: '12px', margin: 0 },
};

export default TeacherTimetable;